import { render, staticRenderFns } from "./ModalAbout.vue?vue&type=template&id=13647726&"
import script from "./ModalAbout.vue?vue&type=script&lang=js&"
export * from "./ModalAbout.vue?vue&type=script&lang=js&"
import style0 from "./ModalAbout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports